import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { SrSalesOrderType, type SrOrderStatus } from '@plato/data/starrocks/types';
import { OrderIcon } from '@plato/ui-legacy/assets/icons/order-icon';
import { QuoteIcon } from '@plato/ui-legacy/assets/icons/quote-icon';
import type { ReactElement } from 'react';
import { formatOrderId } from '../../../lib/order-helpers.ts';
import { QuoteOrderTitleLink } from '../../quote-order-detail/components/quote-order-link.tsx';
import { OrderStatusDot } from '../../statuses/components/order-status-dot.tsx';

type Props = {
    type: SrSalesOrderType;
    transactionId: string;
    customerName: string;
    status: SrOrderStatus;
    statusType: SrSalesOrderType;
};

export function QuoteOrderIdentityCell({
    type,
    transactionId,
    customerName,
    status,
    statusType,
}: Props): ReactElement {
    const appConfig = useAppConfig();
    const Icon = type === SrSalesOrderType.QUOTE ? QuoteIcon : OrderIcon;

    return (
        <div className="flex min-w-0 items-center gap-cozy">
            <Icon className="hidden size-4 shrink-0 text-neutral-400 group-hover/row:text-neutral-900 sm:block" />
            <div className="flex min-w-0 flex-col">
                <QuoteOrderTitleLink type={type} transactionId={transactionId}>
                    {customerName}
                </QuoteOrderTitleLink>
                <span className="flex min-w-0 items-center gap-tight text-caption text-content-weaker">
                    <span className="truncate tabular-nums">{formatOrderId(appConfig, transactionId)}</span>
                    <span aria-hidden className="shrink-0">
                        ·
                    </span>
                    <OrderStatusDot status={status} type={statusType} />
                </span>
            </div>
        </div>
    );
}
